(() => {
  const productRoot = document.querySelector('[data-brine-product]');
  if (!productRoot) return;

  const select = productRoot.querySelector('[data-product-variant]');
  const image = productRoot.querySelector('[data-product-main-image]');
  const price = productRoot.querySelector('[data-product-price]');
  const button = productRoot.querySelector('[data-product-submit]');

  const updateProduct = () => {
    const option = select?.selectedOptions?.[0];
    if (!option) return;
    if (image && option.dataset.image) {
      image.src = option.dataset.image;
      image.alt = option.dataset.title || image.alt;
    }
    if (price && option.dataset.price) price.textContent = option.dataset.price;
    if (button) {
      const available = option.dataset.available === 'true';
      button.disabled = !available;
      button.textContent = available ? 'ADD TO BAG ↗' : 'SOLD OUT';
    }
  };

  select?.addEventListener('change', updateProduct);
  updateProduct();
})();
